module.exports = __webpack_public_path__ + "img/img-29.f8f46022.png";